export const Endpoints =  {
    auth: {
        guest: 'POST /api/auth/guest',
        fetchLatestProfile: 'GET /api/auth/fetchLatestProfile',
        discord: 'GET /api/auth/discord/login',
        guild: 'POST /api/auth/guild/login'
    }
};



// WEBPACK FOOTER //
// ./src/api/endpoints.ts